/**
 * 根据请求回来的数据进行icon的set
 * author:brian
 * date:2022 06 02
 */

// 监测点运行状态
export const stautsIconArray = {
  0: {
    icon: 'iconfont icon-yunhang'
  },
  1: {
    icon: 'iconfont icon-beiyong'
  },
  2: {
    icon: 'iconfont icon-baofei'
  },
  3: {
    icon: 'iconfont icon-daixiugai'
  },
  4: {
    icon: 'iconfont icon-chushuang'
  }
}
export const carrierIcon = {
  incubator: {
    icon: 'iconfont icon-weibolu-xian',
    title: $t('carrier.incubator')
  },
  fridge: {
    icon: 'iconfont icon-bingxiang',
    title: $t('integration.refrigerator')
  },
  car: {
    icon: 'iconfont icon-qiche',
    title: $t('integration.vehicle')
  },
  refrigeratory: {
    icon: 'iconfont icon-9lengku',
    title: $t('integration.cold_storage')
  }
}
// 设备类型
export const deviceTypeSensor = {
  // 传感器
  zbp_1: {
    icon: 'iconfont icon-wenduji',
    value: '',
    label: 'zbp_1'
  },
  zbp_2: {
    icon: 'iconfont icon-wenshiduji',
    value: '',
    label: 'zbp_2'
  },
  lora_1: {
    icon: 'iconfont icon-wenduji1',
    value: '',
    label: 'lora_1'
  },
  lora_2: {
    icon: 'iconfont icon-wenshiduji1',
    value: '',
    label: 'lora_2'
  },
  zeta_1: {
    icon: 'iconfont icon-21pingjunqiwen',
    value: '',
    label: 'zeta_1'
  },
  zeta_2: {
    icon: 'iconfont icon-wenshiduji2',
    value: '',
    label: 'zeta_2'
  }
}
/*
 *
 * @param {* 请求获取到的数据} paramArray
 * @param {* 匹配icon} iconData
 * @param {* 国际化前缀} lang
 * @param {* 是否需要替换字段名 默认false} isBool
 */
export function SET_STATUS_FN (paramArray, iconData, lang = null, isBool = false) {
  (paramArray || []).forEach(item => {
    item.icon = iconData[item.code] && iconData[item.code].icon
    if (!isBool) {
      item.value = item.code
      item.label = item.name
    } else {
      item.value = item.id
      item.label = lang + (item.content || item.code)
    }
  })
  return paramArray
}
